import { Observable, Operator } from "@jetjs/streams";
// type guards
// tslint:disable no-any
export const isOperatorPlugin = (t) => {
    return t instanceof Operator;
};
export const isObserverPlugin = (t) => {
    return (t.next !== undefined &&
        t.start !== undefined &&
        !(t instanceof Operator));
};
export const isObservablePlugin = (t) => {
    return t instanceof Observable;
};
export const isTaskConfiguration = (t) => {
    return (t !== undefined &&
        t.name !== undefined &&
        t.source !== undefined);
};
//# sourceMappingURL=Plugin.js.map